import React from 'react';

import { VerifierBillingRulesModalForm } from 'src/components/account';
import { Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { VerifierBillingRulesChangeModalArgs } from './types';

export const VerifierBillingRulesChange: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<VerifierBillingRulesChangeModalArgs>(ModalId.VerifierBillingRulesChangeModal);

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Verifier Billing Rules Change"
      maxWidth={400}
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
    >
      <VerifierBillingRulesModalForm
        billingRuleIds={args?.billingRuleIds}
        isAllSelected={args?.isAllSelected}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        voi={args?.voi}
        voe={args?.voe}
        reverification={args?.reverification}
      />
    </Modal>
  );
};
